import React, { useContext, useEffect, useState } from "react";
import { tableDataContext } from "../dashboard/context/productData";
import axios from "axios";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Expiry from "../components/Regex/expiry";
import { Icon } from "@iconify/react/dist/iconify.js";
// ...
const GridSection = ({
  holdData,
  handleDeleteHistory,
  selectedTab,
  setSelectedTab,
  favorites,
  handleFavorites,
  handleSaveHistory,
  loader,
  vendorData,
}) => {
  const {
    fullData,
    setFullData,
    filters,
    selectedFilters,
    setSelectedFilters,
    setFilters,
    vendorNames,
    setvendorNames,
    selectedVendor,
    setSelectedVendor,
    filterVendorData,
    setFiltersVendorData,
  } = useContext(tableDataContext);
  const [sliceData, setSliceData] = useState(12);
  const [priceSort, setPriceSort] = useState();
  const [date, setDate] = useState();
  const { id } = useParams();

  useEffect(() => {
    const uniqueVendors = Array.from(
      new Set(vendorData.map((item) => item.vendorName))
    );
    setvendorNames(uniqueVendors);
  }, [fullData, holdData]);

  useEffect(() => {
    if (selectedVendor === "default") {
      if (selectedFilters.length > 0) {
        const filteredResults = vendorData.filter((product) => {
          return selectedFilters.some((filter) => {
            return product.productName
              .toLowerCase()
              .includes(filter.toLowerCase());
          });
        });
        setFullData(filteredResults);
      } else {
        setFullData(vendorData);
      }
    } else if (selectedVendor) {
      const filteredData = vendorData.filter(
        (item) => item.vendorName === selectedVendor
      );
      console.log(selectedFilters);
      if (selectedFilters.length > 0) {
        const filteredResults = filteredData.filter((product) => {
          return selectedFilters.some((filter) => {
            return product.productName
              .toLowerCase()
              .includes(filter.toLowerCase());
          });
        });
        setFullData(filteredResults);
      } else {
        setFullData(filteredData);
      }
    }
  }, [selectedVendor]);

  const handleHoldDataLength = () => {
    const modValue = holdData.length % 12;
    const diff = 12 - modValue;
    const length = holdData.length + diff;
    return length;
  };

  const handleFulLDataLength = () => {
    const modValue = fullData.length % 12;
    const diff = 12 - modValue;
    const length = fullData.length + diff;
    return length;
  };

  const handleSaveData = (data) => {
    console.log(data, "data from grid section...............");
    const payload = {
      pdf_name: data.pdfName,
      old_price: parseFloat(data?.oldPrice?.toString().replace(",", ".")) || 0,
      quantity: parseFloat(data.quantity) || 0,
      current_price:
        parseFloat(data?.currentPrice?.toString().replace(",", ".")) || 0,
      user_identifier: id,
      product_name: data.productName,
      vendor_name: data.vendorName,
      discount: parseFloat(data.discount) || 0,
    };

    axios
      .post(
        "https://aipricingtool-python.onrender.com/send_data_to_frontend",
        payload
      )
      .then(() => {
        toast.success("Favorites saved successfully");
        handleFavorites();
      })
      .catch(() => {
        toast.error("Error saving Favorites");
      });
  };

  const handleDeleteData = (product) => {
    console.log(product);
    const match = holdData.find(
      (fav) =>
        fav.pdfName === product.pdfName &&
        fav.vendorName === product.vendorName &&
        fav.productName === product.productName
    );

    console.log(match);
    if (!match) {
      return;
    }

    axios
      .delete("https://aipricingtool-python.onrender.com/delete_entry", {
        data: {
          user_identifier: id,
          entry_id: match._id,
        },
      })
      .then((res) => {
        handleFavorites();
        toast.success("Favorite Removed successfully");
      })
      .catch((err) => {
        console.error(err.message);
        toast.error("Favorite Removed Failed");
        handleFavorites();
      });
  };

  const handleDeleteSelectedHistory = (product) => {
    axios
      .delete(
        "https://aipricingtool-python.onrender.com/delete_product_from_history",
        {
          data: {
            user_identifier: id,
            product_name: product,
          },
        }
      )
      .then((res) => {
        console.log(selectedFilters);
        if (selectedFilters.includes(product)) {
          toggleFilter(product);
        }
        handleSaveHistory();
        toast.success(res.data.success);
      })
      .catch((err) => {
        console.error(err.data);
        toast.error("Failed to delete!");
      });
  };

  const toggleFilter = (filter) => {
    if (selectedFilters.includes(filter)) {
      setSelectedFilters(selectedFilters.filter((item) => item !== filter));
    } else {
      setSelectedFilters([...selectedFilters, filter]);
    }
  };

  return (
    <>
      {/* Filter Section */}
      {loader ? (
        <div className="flex items-center justify-center h-full w-full mt-4  rounded-full">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="flex lg:flex-row flex-col  w-full lg:justify-between  lg:items-center px-4 text-2xl  font-bold mt-8">
            <div className="flex lg:flex-row flex-col w-full  items-center">
              <h2 className="lg:w-1/5 lg:mb-0  mx-4 w-full">Filters </h2>
              <div className="flex gap-4 flex-wrap  ">
                {filters.length > 0 &&
                  Array.from(new Set(filters))
                    .slice(0, 5)
                    .map((filter) => (
                      <div
                        key={filter}
                        className={`flex items-center space-x-4 pl-4 border !border-[#E3D0A8] rounded-full ${
                          selectedFilters.includes(filter)
                            ? "text-white bg-[#E3D0A8]"
                            : "text-[#E3D0A8] bg-white"
                        }`}
                      >
                        <button onClick={() => toggleFilter(filter)}>
                          {filter}
                        </button>
                        <div
                          onClick={() => {
                            handleDeleteSelectedHistory(filter);
                          }}
                          className="cursor-pointer bg-[#E3D0A8] rounded-full"
                        >
                          <Icon icon="oui:cross" fontSize={25} color="white" />
                        </div>
                      </div>
                    ))}
              </div>
            </div>
            <div className="flex justify-end space-x-4 items-center w-1/2  lg:mt-0 mt-4">
              <button
                className="bg-[#E3D0A8] p-2.5 text-base text-white hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8]"
                onClick={() => handleDeleteHistory()}
              >
                Remove All Filters
              </button>

              {/* ----------------date----------- */}
              <select
                className={` bg-[#E3D0A8] text-white text-base !border-[#E3D0A8] !border  p-2.5 cursor-pointer hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] ${
                  date && date != "default"
                    ? "bg-white !text-[#E3D0A8] !border-[#E3D0A8] !border"
                    : ""
                }`}
                onChange={(e) => setDate(e.target.value)}
                value={date}
              >
                <option value="default">Sort By Date</option>
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="last30days">Last 30 days</option>
              </select>

              <select
                className={` bg-[#E3D0A8] text-white text-base !border-[#E3D0A8] !border  p-2.5 cursor-pointer hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] ${
                  priceSort && priceSort != "default"
                    ? "bg-white !text-[#E3D0A8] !border-[#E3D0A8] !border"
                    : ""
                }`}
                onChange={(e) => setPriceSort(e.target.value)}
                value={priceSort}
              >
                <option value="default">Sort By Price</option>
                <option value="lowtohigh">Low to High</option>
                <option value="hightolow">High to Low</option>
              </select>
              {selectedTab !== "favorites" && (
                <select
                  id="underline_select"
                  className={` bg-[#E3D0A8] text-white text-base !border-[#E3D0A8] !border   p-2.5 cursor-pointer hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] ${
                    selectedVendor && selectedVendor != "default"
                      ? "bg-white !text-[#E3D0A8]  "
                      : ""
                  }`}
                  value={selectedVendor}
                  onChange={(e) => {
                    setSelectedVendor(e.target.value);
                  }}
                >
                  <option selected value="default">
                    Default Vendor
                  </option>
                  {vendorNames.map((vendor) => (
                    <option value={vendor} key={vendor}>
                      {vendor}
                    </option>
                  ))}
                </select>
              )}
            </div>
          </div>
          {/*  Tabs Section */}
          <div className="flex flex-col  items-center  space-y-4  w-full">
            <div className="flex gap-4 w-1/3 items-center justify-between px-4">
              <button
                className={`border-[#E3D0A8] px-4 py-2  text-lg font-bold rounded-full ${
                  selectedTab === "allProduct"
                    ? "text-white bg-[#E3D0A8]"
                    : "text-[#E3D0A8] bg-white"
                }`}
                onClick={() => {
                  setSelectedTab("allProduct");
                  setSelectedFilters([]);
                }}
              >
                All Products
              </button>
              <button
                className={`border-[#E3D0A8] px-4 py-2 text-lg font-bold rounded-full ${
                  selectedTab === "myChains"
                    ? "text-white bg-[#E3D0A8]"
                    : "text-[#E3D0A8] bg-white"
                }`}
                onClick={() => {
                  setSelectedTab("myChains");
                  setSelectedFilters([]);
                }}
              >
                My Chains
              </button>
              <button
                className={`border-[#E3D0A8] px-4 py-2 text-lg font-bold rounded-full ${
                  selectedTab === "favorites"
                    ? "text-white bg-[#E3D0A8]"
                    : "text-[#E3D0A8] bg-white"
                }`}
                onClick={() => {
                  setSelectedTab("favorites");
                  setSelectedFilters([]);
                }}
              >
                Favorites
              </button>
            </div>
          </div>
        </>
      )}
      {/* Slider Section  */}
      {loader && (
        <div className="flex justify-between w-full p-12">
          <div className="loader"></div>
          <div className="loader"></div>
          <div className="loader"></div>
          <div className="loader"></div>
        </div>
      )}
      <div className="flex flex-col p-12 ">
        <div className="grid grid-cols-1 md:grid-cols-2  xl:grid-cols-3 2xl:grid-cols-4 gap-2 ">
          {(priceSort === "lowtohigh"
            ? (selectedTab === "favorites"
                ? [...holdData]
                : [...fullData]
              ).sort((a, b) => {
                const priceA = parseFloat(
                  a.currentPrice?.toString().replace(",", ".") || 0
                );
                const priceB = parseFloat(
                  b.currentPrice?.toString().replace(",", ".") || 0
                );
                return priceA - priceB; // Ascending sort
              })
            : priceSort === "hightolow"
            ? (selectedTab === "favorites"
                ? [...holdData]
                : [...fullData]
              ).sort((a, b) => {
                const priceA = parseFloat(
                  a.currentPrice?.toString().replace(",", ".") || 0
                );
                const priceB = parseFloat(
                  b.currentPrice?.toString().replace(",", ".") || 0
                );
                return priceB - priceA; // Descending sort
              })
            : // ---------------------------- today ----------------
            date === "today"
            ? (selectedTab === "favorites"
                ? [...holdData]
                : [...fullData]
              ).sort((a, b) => {
                const priceA = parseFloat(
                  a.currentPrice?.toString().replace(",", ".") || 0
                );
                const priceB = parseFloat(
                  b.currentPrice?.toString().replace(",", ".") || 0
                );
                return priceA - priceB; // Ascending sort
              })
            : // ---------------------------- yesterday ----------------
            date === "yesterday"
            ? (selectedTab === "favorites"
                ? [...holdData]
                : [...fullData]
              ).sort((a, b) => {
                const priceA = parseFloat(
                  a.currentPrice?.toString().replace(",", ".") || 0
                );
                const priceB = parseFloat(
                  b.currentPrice?.toString().replace(",", ".") || 0
                );
                return priceB - priceA;
              })
            : // ---------------------- 30 days ---------------------
            date === "last30days"
            ? (selectedTab === "favorites"
                ? [...holdData]
                : [...fullData]
              ).filter((data) => {
                const { desiredDate } = data.pdfName
                  ? Expiry(data.pdfName)
                  : { desiredDate: "N/A" };
                const thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                return (
                  desiredDate !== "N/A" &&
                  new Date(desiredDate) >= thirtyDaysAgo
                );
              })
            : selectedTab === "favorites"
            ? holdData
            : fullData
          )
            .slice(0, sliceData)
            .map((data, index) => {
              const { desiredDate } = data.pdfName
                ? Expiry(data.pdfName)
                : { desiredDate: "N/A" };
              return (
                <div>
                  <div
                    className="flex flex-col justify-center items-center text-lg font-bold p-6"
                    key={index}
                  >
                    <div className="relative w-full">
                      <div className="absolute top-8 -right-2 bg-[#E3D0A8] w-14 text-center rounded-t-lg text-red-600 font-bold transform rotate-45 origin-top-right">
                        <p>{data.discount}</p>
                      </div>
                      <div className="flex flex-col justify-around rounded-lg bg-gray-200 border h-40 w-full">
                        <p className="px-4">Expire Date: {data.expire_date || "Not Available"}</p>
                        <div className="tooltip-container">
                          <p className="px-2 text-center overflow-hidden text-ellipsis whitespace-nowrap">
                            {data.productName}
                          </p>
                          <span className="tooltip-text">
                            {data.productName}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col px-4 bg-white w-full">
                      <div>
                        <p>Vendor name: {data.vendorName}</p>
                        <p>Quantity: {data.quantity}</p>
                      </div>
                      <div className="flex flex-wrap justify-between ">
                        {data.oldPrice && (
                          <p>
                            <s>
                              Old Price:{" "}
                              {data?.oldPrice?.toString().replace(",", ".")}
                            </s>
                          </p>
                        )}
                        <p>
                          Price:{" "}
                          {data?.currentPrice?.toString().replace(",", ".")}
                        </p>
                        {favorites.includes(
                          `${data.productName}-${data.vendorName}`
                        ) ? (
                          <Icon
                            icon="gridicons:star"
                            fontSize={25}
                            color="Yellow"
                            onClick={() => handleDeleteData(data)}
                            className="cursor-pointer"
                          />
                        ) : (
                          <Icon
                            className="cursor-pointer"
                            icon="gridicons:star-outline"
                            fontSize={25}
                            onClick={() => handleSaveData(data)}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="flex justify-end  w-full">
          {sliceData >= 13 && (
            <button
              type="button"
              onClick={() => setSliceData(sliceData - 12)}
              className="text-black cursor-pointer text-end px-12 hover:underline-offset-1 hover:text-[#E3D0A8] text-xl "
            >
              Show Less...
            </button>
          )}
          {selectedTab === "favorites"
            ? sliceData < holdData.length
            : sliceData < fullData.length && (
                <button
                  type="button"
                  onClick={() => setSliceData(sliceData + 12)}
                  className="text-black cursor-pointer text-end px-12 hover:underline-offset-1 hover:text-[#E3D0A8] text-xl "
                >
                  Show More...
                </button>
              )}

          {selectedTab === "favorites"
            ? sliceData < holdData.length && holdData.length > 12
            : sliceData < fullData.length &&
              fullData.length > 12 && (
                <button
                  type="button"
                  onClick={() =>
                    setSliceData(
                      selectedTab === "favorites"
                        ? handleHoldDataLength()
                        : handleFulLDataLength()
                    )
                  }
                  className="text-black cursor-pointer text-end px-12 hover:underline-offset-1 hover:text-[#E3D0A8] text-xl "
                >
                  Show All...
                </button>
              )}
        </div>
      </div>
    </>
  );
};

export default GridSection;
